/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SSOCodeExchangeRequest
 */
export interface SSOCodeExchangeRequest {
    /**
     * 
     * @type {string}
     * @memberof SSOCodeExchangeRequest
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof SSOCodeExchangeRequest
     */
    codeVerifier: string;
}

/**
 * Check if a given object implements the SSOCodeExchangeRequest interface.
 */
export function instanceOfSSOCodeExchangeRequest(value: object): value is SSOCodeExchangeRequest {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('codeVerifier' in value) || value['codeVerifier'] === undefined) return false;
    return true;
}

export function SSOCodeExchangeRequestFromJSON(json: any): SSOCodeExchangeRequest {
    return SSOCodeExchangeRequestFromJSONTyped(json, false);
}

export function SSOCodeExchangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSOCodeExchangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'codeVerifier': json['code_verifier'],
    };
}

export function SSOCodeExchangeRequestToJSON(json: any): SSOCodeExchangeRequest {
    return SSOCodeExchangeRequestToJSONTyped(json, false);
}

export function SSOCodeExchangeRequestToJSONTyped(value?: SSOCodeExchangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'code_verifier': value['codeVerifier'],
    };
}

